export default {
	bizOrder: {
		title: 'Work Order Management',
		query: {
			title: 'Work Order Name',
			status: 'Processing Status'
		},
		table: {
			title: 'Work Order Title',
			deviceName: 'Device Name',
			deviceNo: 'Device Number',
			status: 'Work Order Status',
			toPersonName: 'Handler',
			fromPersonName: 'Declarant',
			createTime: 'Creation Time',
			wlevel: 'Alarm Level',
			warnCount: 'Alarm Count',
			action: 'Action'
		},
		buttons: {
			add: 'Add',
			deleteBatch: 'Batch Delete',
			handle: 'Handle',
			detail: 'Details',
			close: 'Close',
			cancel: 'Cancel',
			confirm: 'Confirm',
			diagnosis: 'Diagnosis',
			delete: 'Delete'
		},
		form: {
			title: 'Title',
			content: 'Content',
			remark: 'Remark',
			attachmentList: 'Attachment'
		},
		dialog: {
			add: 'Add Work Order',
			update: 'Complete Work Order',
			detail: 'Work Order Details',
			warnInfo: 'Alarm Information'
		},
		messages: {
			operationSuccess: 'Operation successful',
			deleteConfirm: 'Are you sure you want to delete?',
			batchDeleteConfirm: 'Are you sure you want to batch delete?'
		},
		warnList: {
			title: 'Alarm List',
			warnTitle: 'Alarm Title',
			pointName: 'Sensor Point Name',
			pointId: 'Sensor Point ID',
			dataType: 'Data Type',
			wlevel: 'Alarm Level',
			handleStatus: 'Status',
			startTime: 'Start Time',
			predTime: 'Last Alarm',
                        eigenKey: 'Feature Values',
			content: 'Content',
			standardData: 'Reference Value',
			predData: 'Actual Value',
			warnCount: 'Alarm Count',
			type: 'Alarm Type',
			suggest: 'Suggestion',
			warnType: 'Alarm Classification'
		}
	}
}
